module.exports = __webpack_public_path__ + "static/negy-35808d21d1d17ac1b84d3184e365093b.jpg";